import { render } from "./OrganisationUserAdd.vue?vue&type=template&id=f471c472"
import script from "./OrganisationUserAdd.vue?vue&type=script&lang=js"
export * from "./OrganisationUserAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__